// extracted by mini-css-extract-plugin
export default {"link":"BackButton__link--20F","icon":"BackButton__icon--1k1"};